'use strict';

const Mn = require('backbone.marionette');
const DiagramModel = require('system/domain/entity/diagram');
const MarkdownWriterView = require('common/ui/view/markdown/writer');
const DiagramListView = require('balus/ui/view/body/process/toolbar/diagram-list');
const DiagramRepository = require('system/domain/repository/diagram');
const Template = require('balus/ui/template/body/process/toolbar/diagram-edit.hbs');
const i18n = require('i18next');

module.exports = Mn.View.extend({
    template: Template,
    modelEvents: {
        'destroy': 'remove',
        'change:name': 'uploadable',
        'change:type': 'uploadable',
        'change:description': 'uploadable'
    },
    childViewEvents: {
        'select:diagram': 'uploadable'
    },
    bindings: {
        'input.name': 'name',
        'select.type': {
            observe: 'type',
            selectOptions: {
                collection: DiagramModel.types,
                labelPath: 'name',
                valuePath: 'type'
            }
        },
        '.diagram-icon': {
            observe: 'type',
            updateMethod: 'html',
            onGet: function(value) {
                return `<div class="icon diagram-type-${value}"></div>`;
            }
        },
        'input.description': 'description'
    },
    regions: {
        diagramList: '.diagram-list'
    },

    initialize: function() {
        this.model = new DiagramModel();
        this.listenTo(this._original, 'destroy', this.destroy);
    },

    templateContext: function() {
        return {
            hideNew: this.getOption('hideNew')
        }
    },

    onRender: function() {
        const group = this.getOption('group');
        const project = this.getOption('project');

        if(!this.getOption('hideNew')) {
            // markdown writer
            const writer = new MarkdownWriterView({
                project: project,
                markdown: this.model.get('description'),
                useDataContentSelector: true
            });
            this.$('.diagram-list-item-description').append(writer.render().$el);
            this.listenTo(writer, 'change', function(desc){
                this.model.set('description', desc);
            });

            this.stickit(this.model);
        }

        const context = {
            projectId: project.id
        };
        this.showChildView('diagramList', new DiagramListView({
            group: group,
            model: project,
            context: context,
            collection: DiagramRepository.getDiagrams({
                context: context
            })
        }));

        return this;
    },

    uploadable: function () {
        if(this.model.get('name')) {
            this.trigger('formFilled');
        } else if(this.getChildView('diagramList').getActiveDiagrams().length) {
            this.trigger('formFilled');
        } else {
            this.trigger('formEmpty');
        }
    },

    save: function() {
        return this.getChildView('diagramList').getActiveDiagrams();
    },

    error: function(status) {
        if (status && status.type == 'EmptyNameError') {
            this.$('.diagram-list-item-name .alert-message').html(
                i18n.t('input.diagram.validation.required')
            );
        }
    },

    getActiveModels: function() {
        return this.getChildView('diagramList').getActiveDiagrams();
    }
});



// WEBPACK FOOTER //
// ./balus/ui/view/body/process/toolbar/diagram-edit.js